import { AnyAction } from 'redux';
import { authenticationActionTypes } from '../actions/authActions';
import {
  TokenDataDTO,
  GDPTokenDataDTO,
} from '../../models/dto/AuthenticationDTO';

export interface AuthReducerState {
  tokenData: TokenDataDTO | null;
  gdpTokenData: GDPTokenDataDTO | null;
  errorMessage: string;
  sessionExpired: boolean;
  loading: boolean;
}

const initialState: AuthReducerState = {
  tokenData: null,
  gdpTokenData: null,
  errorMessage: '',
  sessionExpired: false,
  loading: false,
};

export default (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case authenticationActionTypes.LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case authenticationActionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        tokenData: action.payload,
        loading: false,
      };
    case authenticationActionTypes.LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload,
      };
    case authenticationActionTypes.AUTH_GDP_USER: {
      return {
        ...state,
        gdpTokenData: action.payload,
      };
    }
    case authenticationActionTypes.LOGOUT:
      return {
        ...initialState,
        sessionExpired: action.payload,
      };

    default:
      return state;
  }
};
